// https://router.vuejs.org/api/interfaces/routeroptions.html
import type { RouterConfig } from '@nuxt/schema'

const pages = [
  // 匹配页
  // {
  //   path: '/match',
  //   name: 'Match',
  //   component: () => import('@/pages/Match/index.vue')
  // },
  // 主播首页
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/Home/index.vue')
  },
  // 我的资料页
  {
    path: '/aboutme',
    name: 'Aboutme',
    component: () => import('@/pages/Aboutme/index.vue')
  },
  // 编辑个人资料页
  {
    path: '/editProfile',
    name: 'EditProfile',
    component: () => import('@/pages/EditProfile/index.vue')
  },
  // 关注列表页
  {
    path: '/userList',
    name: 'UserList',
    component: () => import('@/pages/Aboutme/UserList.vue')
  },
  // 私聊列表
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/pages/Chat/index.vue')
  },
  // 私聊页
  {
    path: '/chatPage',
    name: 'ChatPage',
    component: () => import('@/pages/Chat/ChatPage.vue')
  },
  // 充值页
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('@/pages/Recharge/index.vue')
  },
  // 充值结果页
  {
    path: '/recharge/result',
    name: 'Result',
    component: () => import('@/pages/Recharge/Result.vue')
  },
  // 关于我们
  {
    path: '/draftstatic/about',
    name: 'About',
    component: () => import('@/pages/Draftstatic/About.vue')
  },
  // 隐私
  {
    path: '/draftstatic/privacy',
    name: 'Privacy',
    component: () => import('@/pages/Draftstatic/Privacy.vue')
  },
  // 直播页
  {
    path: '/room/live',
    name: 'RoomLive',
    component: () => import('@/pages/Room/Live.vue')
  },
  // 语音房
  {
    path: '/room/audio',
    name: 'RoomAudio',
    component: () => import('@/pages/Room/Audio.vue')
  },
  // App语音房
  {
    path: '/roomApp/audio',
    name: 'RoomAppAudio',
    component: () => import('@/pages/RoomApp/Audio.vue')
  },
  // App直播页
  {
    path: '/roomApp/live',
    name: 'RoomAppLive',
    component: () => import('@/pages/RoomApp/Live.vue')
  },
  // // 视频通话
  // {
  //   path: '/room/call',
  //   name: 'RoomCall',
  //   component: () => import('@/pages/Room/Call.vue')
  // },
  // // 等待接听
  // {
  //   path: '/room/callWaiting',
  //   name: 'CallWaiting',
  //   component: () => import('@/pages/Room/CallWaiting.vue')
  // },
  // // 匹配中
  // {
  //   path: '/match/matching',
  //   name: 'Matching',
  //   component: () => import('@/pages/Match/Matching.vue')
  // }
  // 搜索页
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/pages/Search/index.vue')
  }
]

export default <RouterConfig>{
  routes: () => {
    const runtimeConfig = useRuntimeConfig()
    // 配置路由，过滤App或不过滤app路由
    // 定义您希望保留的路径特征，例如包含 'App' 的路径
    const includePattern = /App/
    // 确保环境变量正确解析为布尔值
    if (runtimeConfig.public.isAppPack) {
      // 根据环境变量决定是保留还是排除匹配的路由
      pages.splice(
        0,
        pages.length,
        ...pages.filter((page) => includePattern.test(page.path))
      )
    }

    return pages
  }
}
